/**************************************************
 * Nombre:       Home_Lineas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {motion, useScroll, useTransform} from "framer-motion";

const Home_Lineas = () => {
    const speed = 1;
    const {scrollY} = useScroll();
    const x = useTransform(scrollY, (value) => -value * speed);
    const y = useTransform(scrollY, (value) => value * speed);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{overflowX: 'hidden', py: 4}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{overflowX: 'hidden', transform: 'rotate(-2.1deg)'}}>
                <Grid
                    component={motion.div}
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{backgroundColor: '#9CAD6C', py: 1.5, zIndex: 2, minWidth: 3500, maxLines: 1}}
                    style={{x: x, transitionTimingFunction: "spring(1 100 10 10)", transition: "transform 3s"}}
                >

                    {lista.map((item) => {
                        return (

                            <Typography
                                sx={{
                                    color: '#000',
                                    mx: 0.2,
                                    fontSize: 20,
                                    maxLines: 1,
                                    fontWeight: 800
                                }}>{`${item}  |  `}</Typography>


                        )
                    })}


                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{overflowX: 'hidden', mt: 2, transform: 'rotate(1.36deg)'}}>
                <Grid
                    component={motion.div}
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{backgroundColor: '#000', py: 1.5, zIndex: 2, minWidth: 3500, maxLines: 1, ml: -150}}
                    style={{x: y, transitionTimingFunction: "spring(1 100 10 10)", transition: "transform 3s"}}
                >

                    {lista.map((item) => {
                        return (

                            <Typography
                                sx={{
                                    color: '#fff',
                                    mx: 0.2,
                                    fontSize: 20,
                                    maxLines: 1,
                                    fontWeight: 800
                                }}>{`${item}  |  `}</Typography>


                        )
                    })}


                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Lineas

const lista = ["BRANDING", "ESTRATEGIA", "GESTION DE MARCA", "BRANDING", "ESTRATEGIA", "GESTION DE MARCA", "BRANDING", "ESTRATEGIA", "GESTION DE MARCA", "BRANDING", "ESTRATEGIA", "GESTION DE MARCA", "BRANDING", "ESTRATEGIA", "GESTION DE MARCA", "BRANDING", "ESTRATEGIA", "GESTION DE MARCA", "BRANDING", "ESTRATEGIA", "GESTION DE MARCA",]